import MockAdapter from 'axios-mock-adapter';
import { logger } from '@/utils/logger';
import request from '../utils/request';

// 创建 mock 实例
const mock = new MockAdapter(request, {
  // 设置默认的延迟时间
  delayResponse: 200,
  // 设置是否在找不到匹配的 mock 时返回 404
  onNoMatch: 'passthrough',
});

// 初始化所有 mock
export const setupMocks = () => {
  // 在 mock 环境下启用所有 mock
  if (import.meta.env.MODE === 'mock') {
    logger.info('Initializing mocks...');
    // 导入并设置 auth mock
    import('./auth')
      .then(({ setupAuthMock }) => {
        setupAuthMock(mock);
        logger.info('Auth mock setup completed');
      })
      .catch(error => {
        logger.error('Failed to setup auth mock:', error);
      });

    // 导入并设置 chat mock
    import('./chat')
      .then(({ setupChatMock }) => {
        setupChatMock(mock);
        logger.info('Chat mock setup completed');
      })
      .catch(error => {
        logger.error('Failed to setup chat mock:', error);
      });

    // 导入并设置 erp mock
    import('./erp')
      .then(({ setupErpMock }) => {
        setupErpMock(mock);
        logger.info('ERP mock setup completed');
      })
      .catch(error => {
        logger.error('Failed to setup ERP mock:', error);
      });
  }
};

// 导出 mock 实例
export default mock;
